import {
  mentionTextareaStyles,
  SKUFontDefinitionStyles,
} from "../../helpers/createGlobalStyle";

export const additionalGlobalStyle = (p) => `
${SKUFontDefinitionStyles}
${mentionTextareaStyles(p)}
.csku-styles {
  font-family: ${
    (p.theme && p.theme.fontFamily) ||
    "'skufont-regular', 'sans-serif', 'Roboto'"
  };
}
.popup.select-theme-popup .popup-content.select-theme-popup-content,
.select-featured-product-popup .popup-content.select-featured-product-popup-content.selected-featured-product {
  height: 100%;
}
.popup.select-theme-popup .popup-content.select-theme-popup-content ul:first-of-type {
  padding-left: 1rem;
}
.popup.select-theme-popup .popup-content.select-theme-popup-content ul:first-of-type li {
  padding: 0
}
.main-content.shop .labeled-color-picker-select > label,
.main-content.shop .product_list_style_container label[for="product_list_style"],
.main-content.shop .product_page_style_container label[for="product_page_style"] {
  font-weight: normal;
  font-family: var(--font-family-regular);
  font-size: 16px;
}

.popup.select-image-popup .popup-content.select-image-popup-content,
.popup.select-category-popup .popup-content.select-category-popup-content {
  overflow-y: unset;
}

.storefront-left-preview .image-gallery-slides {
  width: 100%;
}

.shop .storefront-right-sidebar > .customizations-sidebar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
}

.select-category-popup .popup-content.select-category-popup-content.select-category-upload-image {
  width: 100%;
}

.shop .extra-categories-options .extra-categories-select .commonsku-styles-select__control {
  border: none;
  border-color: unset;
  box-shadow: none;
}
.shop .extra-categories-options .extra-categories-select .commonsku-styles-select__control .commonsku-styles-select__value-container {
  padding-right: 0;
}
.shop .extra-categories-options .extra-categories-select .commonsku-styles-select__control .commonsku-styles-select__single-value {
  color: ${p.theme?.template_color || "var(--color-primary)"};
  font-family: var(--font-family-bold);
  font-size: 17px;
}
.shop .extra-categories-options .extra-categories-select .commonsku-styles-select__menu {
  border: 1px solid ${p.theme?.template_color || "var(--color-primary)"};
  border-top: 1px solid ${p.theme?.template_color || "var(--color-primary)"};
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-shadow: 1px 1px 0px ${p.theme?.template_color || "var(--color-primary)"},
    -1px -1px 0px ${p.theme?.template_color || "var(--color-primary)"},
    1px -1px 0px ${p.theme?.template_color || "var(--color-primary)"},
    -1px 1px 0px ${p.theme?.template_color || "var(--color-primary)"};
}
.shop .extra-categories-options .extra-categories-select .commonsku-styles-select__menu
  .commonsku-styles-select__option.commonsku-styles-select__option--is-selected {
  background: ${p.theme?.template_color || "var(--color-primary)"};
}
.shop .extra-categories-options .extra-categories-select
  .commonsku-styles-select__indicator.commonsku-styles-select__dropdown-indicator,
.shop .extra-categories-options .extra-categories-select
  .commonsku-styles-select__indicator.commonsku-styles-select__dropdown-indicator > svg {
  color: ${p.theme?.template_color || "var(--color-primary)"};
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  #storefront-template-iframe {
    zoom: 1;
  }
}
`;
